/**
 * i18n で使用する共通キーの定義
 */
export const I18N_COMMON_KEYS = {
  // 一般的なアクション
  OK: 'ok',
  CANCEL: 'cancel',
  SAVE: 'save',
  CLEAR: 'clear',
  EXECUTE: 'execute',
  CLOSE: 'close',
  LOADING: 'loading',
  CONFIRM: 'confirm',
  DELETE: 'delete',
  EDIT: 'edit',
  CREATE: 'create',
  BACK: 'back',
  NEXT: 'next',
  PREVIOUS: 'previous',
  SEARCH: 'search',
  RESET: 'reset',
  UPLOAD: 'upload',
  DOWNLOAD: 'download',

  // 状態・メッセージ
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  CONFIRMATION_TITLE: 'confirmationTitle',
  EXECUTION_WARNING: 'executionWarning',
  NOT_FOUND: 'notFound',

  // ダイアログ・トースト関連
  DIALOG_OK: 'dialogOk',
  DIALOG_CANCEL: 'dialogCancel',
  DIALOG_CLOSE: 'dialogClose',
  TOAST_GENERAL_ERROR: 'Toast.GeneralError',
  TOAST_UPDATE_SUCCESS: 'Toast.UpdateSuccess',

  // 必要に応じて追加...
} as const
